/**
 * File location-load-more.js.
 *
 * Custom code to load more locations.
 *
 */

( function( $ ) {

	// Trigger Map Click.
	$(document).on('click', '.location__map-icon', function() {
		$("html, body").animate({ scrollTop: $('.facetwp-type-map').offset().top - 100 }, 1000);
		var postid = $(this).attr('data-location-id');
		var markers = FWP_MAP.get_post_markers(postid);
		$.each( markers, function( key, value ) {
			FWP_MAP.map.setZoom(11);
			FWP_MAP.map.setCenter(markers[key].getPosition());
			google.maps.event.trigger(value, 'click');
		});

	});

	$(document).keypress(function(event){
		if ( 'undefined' !== typeof FWP ) {
			if ($('.location-finder-address.in-hero').length > 0 ) {
				var keycode = (event.keyCode ? event.keyCode : event.which);
				if ( keycode == '13' ) {
					var geocoder = new google.maps.Geocoder();
					var zipcode = $('.location-finder-address').val();
					const isValidZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipcode);
			
					if ( isValidZip ) {
						zipcode = zipcode + ',US';
					}
					
					geocoder.geocode( { 'address': zipcode }, function(results, status) {
						if (status == google.maps.GeocoderStatus.OK) {
							if ( results[0].address_components[0].types.includes('postal_code') ) {
								FWP.facets['location_search'] = [results[0].formatted_address];
								window.location.href = `/locations/?_location_search=${results[0].geometry.location.lat()},${results[0].geometry.location.lng()},100,${results[0].formatted_address}`;
							} else {
								// zip code not found, default to somewhere in the US where there are no locations.
								window.location.href = `/locations/?_location_search=71.2858458,-156.9253042,100,Utqiagvik, AK 99723`;
							}
						}
					});
				}
			}

			if ( $('.location-finder-address.on-page').length > 0 ) {
				var keycode = (event.keyCode ? event.keyCode : event.which);
				if ( keycode == '13' ) {
					var geocoder = new google.maps.Geocoder();
					var zipcode = $('.location-finder-address').val();

					const isValidZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipcode);

					if ( isValidZip ) {
						zipcode = zipcode + ',US';
					}

					geocoder.geocode( { 'address': zipcode }, function(results, status) {
						if (status == google.maps.GeocoderStatus.OK) {
							if ( results[0].address_components[0].types.includes('postal_code') ) {
								FWP.facets['location_search'] = [results[0].formatted_address];
								$('.facetwp-lat').val([results[0].geometry.location.lat()]);
								$('.facetwp-lng').val([results[0].geometry.location.lng()]);
							} else {
								// zip code not found, default to somewhere in the US where there are no locations.
								FWP.facets['location_search'] = 'Utqiagvik, AK 99723';
								$('.facetwp-lat').val('71.2858458');
								$('.facetwp-lng').val('-156.9253042');
							}
							FWP.autoload();
						}
					});
				}
			}
		}
	});

	$(document).on('click', '.btn--location-finder.in-hero', function(e) {
		if ( 'undefined' !== typeof FWP ) {
			var geocoder = new google.maps.Geocoder();
			var zipcode = $('.location-finder-address').val();
			const isValidZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipcode);

			if ( isValidZip ) {
				zipcode = zipcode + ',US';
			}
			
			geocoder.geocode( { 'address': zipcode }, function(results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					if ( results[0].address_components[0].types.includes('postal_code') ) {
						FWP.facets['location_search'] = [results[0].formatted_address];
						window.location.href = `/locations/?_location_search=${results[0].geometry.location.lat()},${results[0].geometry.location.lng()},100,${results[0].formatted_address}`;
					} else {
						// zip code not found, default to somewhere in the US where there are no locations.
						window.location.href = `/locations/?_location_search=71.2858458,-156.9253042,100,Utqiagvik, AK 99723`;
					}
				}
			});
		}
	});

	$(document).on('click', '.btn--location-finder.on-page', function() {
		var geocoder = new google.maps.Geocoder();
		var zipcode = $('.location-finder-address').val();

		const isValidZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipcode);

		if ( isValidZip ) {
			zipcode = zipcode + ',US';
		}

		geocoder.geocode( { 'address': zipcode }, function(results, status) {
			if (status == google.maps.GeocoderStatus.OK) {
				if ( results[0].address_components[0].types.includes('postal_code') ) {
					FWP.facets['location_search'] = [results[0].formatted_address];
					$('.facetwp-lat').val([results[0].geometry.location.lat()]);
					$('.facetwp-lng').val([results[0].geometry.location.lng()]);
				} else {
					// zip code not found, default to somewhere in the US where there are no locations.
					FWP.facets['location_search'] = 'Utqiagvik, AK 99723';
					$('.facetwp-lat').val('71.2858458');
					$('.facetwp-lng').val('-156.9253042');
				}
				FWP.autoload();
			}
		});
	});

	// remove the autocomplete box.
	$(document).on('facetwp-loaded', function() {
		$('.location-results').css('visibility', 'hidden');
		if ( FWP.loaded && 0 == FWP.settings.pager.total_rows) {
			$('.chapter__locations').hide();
		} else {
			$('.chapter__locations').show();
		}

		var ajaxurl = window.location.origin + '/wp-admin/admin-ajax.php';
		// Location Load More.
		$('.load--more').on('click', function() {
			let parent_div = $(this).parent();
			let current_btn = $(this);
			let offset = parseInt(parent_div.attr('data-offset'));
			let new_offset = offset + 1;
			let max_pages = $(this).parent().data('max-pagination');
			let locations = $(this).parent().data('locations');
			let div_to_append = $(this).prev();
	
	
			$.ajax({
				type: 'POST',
				url: ajaxurl,
				dataType: 'html',
				data: {
					action: 'load_locations',
					offset: new_offset,
					locations: locations,
				},
				success: function(response) {
					parent_div.attr('data-offset', new_offset );
					$(response).appendTo(div_to_append);
					if (new_offset == max_pages) {
						current_btn.hide();
					}
				},
				error: function(XMLHttpRequest, textStatus, errorThrown) {
					console.log(XMLHttpRequest, textStatus, errorThrown);
				}
			});
	
		});
	});
} )( window.jQuery );
